module.exports = __webpack_public_path__ + "fonts/e2ca235.ttf";